/**
 * Resolves file URLs from various formats (S3 URLs, local paths) to a working URL.
 * 
 * Handles:
 * - S3 URLs: https://bucket.s3.region.amazonaws.com/uploads/... → /api/uploads/...
 * - API paths: /api/uploads/... → /api/uploads/...
 * - Legacy paths: /uploads/... → /api/uploads/...
 * - Null/undefined: returns empty string
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function resolveFileUrl(url) {
  if (!url) return '';

  // Already a full non-S3 URL (e.g., external images)
  if (url.startsWith('http') && !url.includes('amazonaws.com') && !url.includes('s3.')) {
    return url;
  }

  // S3 URL → extract key and convert to proxy path
  if (url.includes('amazonaws.com/')) {
    const key = url.split('amazonaws.com/')[1]; // e.g., "uploads/gallery/xxx.jpg"
    return `${BACKEND_URL}/api/${key}`;
  }

  // Already an /api/ path
  if (url.startsWith('/api/')) {
    return `${BACKEND_URL}${url}`;
  }

  // Legacy /uploads/ path (missing /api prefix)
  if (url.startsWith('/uploads/')) {
    return `${BACKEND_URL}/api${url}`;
  }

  // Relative path
  return `${BACKEND_URL}/api/uploads/${url}`;
}
